import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {FileDetails} from '../model/file-details.model';
import * as FormData from 'form-data';

@Injectable()
export class FileService {
    private readonly httpClient: HttpClient;

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    // TODO: Remove the userId
    public async upload(userId: string, file: File): Promise<string> {
        const url = `${ConfigService.getFileManagementServiceUrl()}/file/upload`;
        const formData = this.getFormData(file);
        const response: any = await this.httpClient.post<{ fileId: string }>(url, formData).toPromise();
        return response.fileId;
    }

    public getFileDownloadUrl(fileId: string): string {
        return `${ConfigService.getFileManagementServiceUrl()}/file/${fileId}`;
    }

    public async getFileData(fileId: string): Promise<FileDetails> {
        const url = `${ConfigService.getFileManagementServiceUrl()}/file/${fileId}/meta`;
        return await this.httpClient.get<FileDetails>(url).toPromise();
    }

    protected getFormData(file: File) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return formData;
    }
}


